<template>
  <th class="border-b border-slate-200 px-2 py-1 text-left transition-colors dark:border-slate-600">
    <slot />
  </th>
</template>

<script setup lang="ts"></script>
